"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var Icon_1 = require("office-ui-fabric-react/lib/Icon");
var mobx_1 = require("mobx");
var mobx_react_1 = require("mobx-react");
var Panel_1 = require("office-ui-fabric-react/lib/Panel");
var owa_accessibility_1 = require("owa-accessibility");
var owa_controls_feature_flags_1 = require("owa-controls-feature-flags");
var owa_header_store_1 = require("owa-header-store");
var owa_common_strings_1 = require("owa-strings/owa-common-strings");
var hostLocation_1 = require("owa-url/lib/hostLocation");
var React = require("react");
var owa_url_1 = require("owa-url");
var getUserConfiguration_1 = require("owa-session-store/lib/actions/getUserConfiguration");
var styles = require('./WafflePane.scss');
var classNames = require('classnames/bind');
var indexedReactDefaultPage = owa_url_1.getMailPath() + 'default.aspx';
var indexedCalendarDefaultPage = owa_url_1.getCalendarPath() + 'default.aspx';
var indexedPeopleDefaultPage = owa_url_1.getPeoplePath() + 'default.aspx';
function createAppTile(displayName, icon, consumerHref, enterpriseHref, hoverBackground) {
    return {
        displayName: displayName,
        icon: icon,
        href: owa_controls_feature_flags_1.isControlFeatureEnabled('fwk-consumerWaffle') ? consumerHref : enterpriseHref,
        hoverBackground: hoverBackground,
    };
}
function getUrlWithAbsolutePath(pageRelativePath) {
    return hostLocation_1.getHostLocation().href.replace(hostLocation_1.getHostLocation().pathname, pageRelativePath);
}
function isOwaMailReactLocation() {
    var lowercasePathname = hostLocation_1.getHostLocation().pathname.toLowerCase();
    if (lowercasePathname === owa_url_1.getMailPath() || lowercasePathname === indexedReactDefaultPage) {
        return true;
    }
    return false;
}
function isOwaCalendarReactLocation() {
    var lowercasePathname = hostLocation_1.getHostLocation().pathname.toLowerCase();
    if (lowercasePathname === owa_url_1.getCalendarPath() ||
        lowercasePathname === indexedCalendarDefaultPage) {
        return true;
    }
    return false;
}
function isOwaPeopleReactLocation() {
    var lowercasePathname = hostLocation_1.getHostLocation().pathname.toLowerCase();
    if (lowercasePathname === owa_url_1.getPeoplePath() || lowercasePathname === indexedPeopleDefaultPage) {
        return true;
    }
    return false;
}
function isPhotoHubReactLocation() {
    var lowercasePathname = hostLocation_1.getHostLocation().pathname.toLowerCase();
    if (lowercasePathname === owa_url_1.getPhotoHubPath()) {
        return true;
    }
    return false;
}
function isFilesHubReactLocation() {
    var lowercasePathname = hostLocation_1.getHostLocation().pathname.toLowerCase();
    if (lowercasePathname === owa_url_1.getFilesHubPath()) {
        return true;
    }
    return false;
}
function getMailAppHref() {
    return isOwaMailReactLocation() ? '' : getUrlWithAbsolutePath(owa_url_1.getMailPath());
}
function getPhotoHubAppHref() {
    return isPhotoHubReactLocation() ? '' : getUrlWithAbsolutePath(owa_url_1.getPhotoHubPath());
}
function getFilesHubAppHref() {
    return isFilesHubReactLocation() ? '' : getUrlWithAbsolutePath(owa_url_1.getFilesHubPath());
}
function getCalendarAppHref() {
    return isOwaCalendarReactLocation() ? '' : getUrlWithAbsolutePath(owa_url_1.getCalendarPath());
}
function getPeopleAppHref() {
    return isOwaPeopleReactLocation() ? '' : hostLocation_1.getHostLocation().origin + owa_url_1.getPeoplePath();
}
function createPhotoOrFilesHubAppTile() {
    var isFilesHubEnabled = owa_controls_feature_flags_1.isControlFeatureEnabled('doc-fileshub');
    var appHRef = isFilesHubEnabled ? getFilesHubAppHref() : getPhotoHubAppHref();
    return createAppTile(isFilesHubEnabled ? 'Files' : owa_common_strings_1.default.appPhotos, // TODO: Localize (Bug: 23430)
    isFilesHubEnabled ? "Attach" /* Attach */ : "Photo2" /* Photo2 */, appHRef, appHRef, styles.appFilesPhoto);
}
function isCalendarFlightSettingEnabled() {
    var userOptions = getUserConfiguration_1.default().UserOptions;
    if (userOptions && userOptions.ReactOptinSettings) {
        return userOptions.ReactOptinSettings.CalendarEnabled;
    }
    else {
        return false;
    }
}
function isPeopleFlightSettingEnabled() {
    var userOptions = getUserConfiguration_1.default().UserOptions;
    if (userOptions && userOptions.ReactOptinSettings) {
        return userOptions.ReactOptinSettings.PeopleEnabled;
    }
    else {
        return false;
    }
}
var Apps = mobx_1.computed(function () {
    return [
        createAppTile(owa_common_strings_1.default.appMail, "Mail" /* Mail */, getMailAppHref(), getMailAppHref(), styles.appMail),
        createAppTile(owa_common_strings_1.default.appCalendar, "Calendar" /* Calendar */, owa_controls_feature_flags_1.isControlFeatureEnabled('cal-react') || isCalendarFlightSettingEnabled()
            ? getCalendarAppHref()
            : owa_url_1.getOwaUrlWithAddedQueryParameters({ path: '/calendar' }), owa_controls_feature_flags_1.isControlFeatureEnabled('cal-react') || isCalendarFlightSettingEnabled()
            ? getCalendarAppHref()
            : owa_url_1.getOwaUrlWithAddedQueryParameters({ path: '/calendar' }), styles.appCalendar),
        createAppTile(owa_common_strings_1.default.appPeople, "People" /* People */, owa_controls_feature_flags_1.isControlFeatureEnabled('fwk-peopleReact') || isPeopleFlightSettingEnabled()
            ? getPeopleAppHref()
            : owa_url_1.getOwaUrlWithAddedQueryParameters({ path: '/people' }), owa_controls_feature_flags_1.isControlFeatureEnabled('fwk-peopleReact') || isPeopleFlightSettingEnabled()
            ? getPeopleAppHref()
            : owa_url_1.getOwaUrlWithAddedQueryParameters({ path: '/people' }), styles.appPeople),
    ]
        .concat(owa_controls_feature_flags_1.isControlFeatureEnabled('doc-photohub') || owa_controls_feature_flags_1.isControlFeatureEnabled('doc-fileshub')
        ? [createPhotoOrFilesHubAppTile()]
        : [])
        .concat([
        createAppTile(owa_common_strings_1.default.appOneDrive, "OneDrive" /* OneDrive */, 'https://onedrive.live.com', 'https://microsoft-my.sharepoint.com/_layouts/15/MySite.aspx?MySiteRedirect=AllDocuments', styles.appOneDrive),
        createAppTile(owa_common_strings_1.default.appTasks, "CheckboxComposite" /* CheckboxComposite */, owa_url_1.getOwaUrlWithAddedQueryParameters({ path: '/tasks' }), owa_url_1.getOwaUrlWithAddedQueryParameters({ path: '/tasks' }), styles.appTasks),
        createAppTile(owa_common_strings_1.default.appWord, "WordLogo" /* WordLogo */, 'https://office.live.com/start/Word.aspx?auth=1', 'https://office.live.com/start/Word.aspx?auth=2', styles.appWord),
        createAppTile(owa_common_strings_1.default.appExcel, "ExcelLogo" /* ExcelLogo */, 'https://office.live.com/start/Excel.aspx?auth=1', 'https://office.live.com/start/Excel.aspx?auth=2', styles.appExcel),
        createAppTile(owa_common_strings_1.default.appPowerPoint, "PowerPointLogo" /* PowerPointLogo */, 'https://office.live.com/start/PowerPoint.aspx?auth=1', 'https://office.live.com/start/PowerPoint.aspx?auth=2', styles.appPowerPoint),
        createAppTile(owa_common_strings_1.default.appOneNote, "OneNoteLogo" /* OneNoteLogo */, 'https://www.onenote.com/notebooks?auth=1', 'https://www.onenote.com/notebooks?auth=2', styles.appOneNote),
        createAppTile(owa_common_strings_1.default.appSway, "SwayLogoInverse" /* SwayLogoInverse */, 'https://sway.com', 'https://sway.com', styles.appSway),
    ])
        .concat(owa_controls_feature_flags_1.isControlFeatureEnabled('fwk-consumerWaffle')
        ? [
            createAppTile(owa_common_strings_1.default.appSkype, "SkypeLogo" /* SkypeLogo */, 'https://web.skype.com/?source=owa', '', styles.appSkype),
            createAppTile(owa_common_strings_1.default.appOffice, "OfficeLogo" /* OfficeLogo */, 'https://office.live.com/start/default.aspx?auth=1&nf=1', '', styles.appOffice),
            createAppTile(owa_common_strings_1.default.appBing, "BingLogo" /* BingLogo */, 'https://www.bing.com/?FORM=MO0027', '', styles.appBing),
            createAppTile(owa_common_strings_1.default.appMSN, "MsnLogo" /* MsnLogo */, 'https://www.msn.com/?OCID=CALHeader', '', styles.appMSN),
            createAppTile(owa_common_strings_1.default.appFlow, "Flow" /* Flow */, 'https://flow.microsoft.com/manage/?utm_source=consumer_office&utm_medium=app_launcher&utm_campaign=consumer_referrals', '', styles.appFlow),
        ]
        : [])
        .concat(owa_controls_feature_flags_1.isControlFeatureEnabled('fwk-bookingsModule')
        ? [
            createAppTile(owa_common_strings_1.default.appBookings, "BookingsLogo" /* BookingsLogo */, owa_url_1.getOwaUrlWithAddedQueryParameters({ path: '/bookings' }), owa_url_1.getOwaUrlWithAddedQueryParameters({ path: '/bookings' }), styles.appBookings),
        ]
        : []);
});
var AppsContextMenu = mobx_react_1.observer(function (props) { return (React.createElement("div", { className: styles.appsContainer }, Apps.get().map(function (appTile) {
    var tileClasses = classNames(styles.app, appTile.hoverBackground);
    var ariaProps = {
        role: owa_accessibility_1.AriaRoles.menuitem,
        label: appTile.displayName,
    };
    return (React.createElement("a", tslib_1.__assign({ "data-is-focusable": true, href: appTile.href, target: '_blank', className: tileClasses, onClick: props.onDismiss }, owa_accessibility_1.generateDomPropertiesForAria(ariaProps)),
        React.createElement(Icon_1.Icon, { className: styles.icon, iconName: appTile.icon }),
        React.createElement("div", { className: styles.text }, appTile.displayName)));
}))); });
var WaffleCharm = /** @class */ (function (_super) {
    tslib_1.__extends(WaffleCharm, _super);
    function WaffleCharm() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WaffleCharm.prototype.render = function () {
        return (React.createElement(Panel_1.Panel, { className: styles.appPane, isLightDismiss: true, isOpen: owa_header_store_1.headerStore.activeCharm === 5 /* WaffleCharm */, hasCloseButton: false, onDismiss: this.props.onDismiss, type: Panel_1.PanelType.smallFixedNear },
            React.createElement(AppsContextMenu, { onDismiss: this.props.onDismiss })));
    };
    WaffleCharm = tslib_1.__decorate([
        mobx_react_1.observer
    ], WaffleCharm);
    return WaffleCharm;
}(React.Component));
exports.default = WaffleCharm;
//# sourceMappingURL=WafflePane.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/header/owa-header-pane/lib/components/WafflePane.js
// module id = 6228
// module chunks = 38